import React, { useEffect, useState } from "react";
// import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatNumber } from "../../../../common/Validations";

const CompareLineItemTable = (props) => {
  const [quotationDocument, setQuotationDocument] = useState([]);
  console.log("Quotation", quotationDocument)
  const [rfxQuestions, setRfxQuestions] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [getPageStatus, setPageStatus] = useState(false);

  // const [getItemLevelData, setItemLevelData] = useState([]);
  // const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  // const [getModalTitle, setModalTitle] = useState("");
  // const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // const lineItemColInfo = [
  //   {
  //     name: "Item Text Code",
  //     cell: (row) => <span>{row.documentId} </span>,
  //     width: "200px",
  //   },
  //   {
  //     name: "Item Text",
  //     cell: (row) => <span>{row.prItemNr} </span>,
  //     width: "250px",
  //   },
  // ];

  // const itemLevelHideModal = () => {
  //   setItemLevelModalShow(false);
  // };

  // // OnClick on lineItem  Data
  // const lineItemShowModal = (itemLevelData) => {
  //   setItemLevelData(itemLevelData);
  //   setItemLevelColumns(lineItemColInfo);
  //   setModalTitle("Line Item Details");
  //   setItemLevelModalShow(true);
  // };
  useEffect(() => {
    if (
      !isInitialized &&
      props?.data?.length > 0 &&
      props?.data[0]?.items?.length > 0
    ) {
      setQuotationDocument(props?.data[0]?.items[0]?.quotationDocument);
      setRfxQuestions(props?.data[0]?.items);
      setPageStatus(props?.pageStatus);
      setIsInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, isInitialized]);

  useEffect(() => {
    props?.sendDataToParent(rfxQuestions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxQuestions]);
  // Update Comments
  // eslint-disable-next-line no-unused-vars
  const handleCommentsInput = (quotationNr, rfxItemNr, value) => {
    // eslint-disable-next-line no-unused-vars
    const updatedData = rfxQuestions?.map((rfxItem) => {
      const updatedQuotationDocument = rfxItem.quotationDocument?.map(
        (item) => {
          // Check if the quotationNr matches, then update the score
          return item.quotationNr === quotationNr
            ? {
              ...item,
              comments: value, // Update the score
            }
            : item; // Return unchanged if quotationNr doesn't match
        }
      );

      // Return the updated rfxItem with the updated quotationDocument
      return rfxItem.rfxItemNr === rfxItemNr
        ? {
          ...rfxItem,
          quotationDocument: updatedQuotationDocument,
        }
        : rfxItem;
    });
  };

  return (
    <div
      className={
        quotationDocument?.length > 4
          ? "generatedTable width-400"
          : "generatedTable width-200"
      }
    >
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="tableHeader"></th>
            <th className="tableHeader"></th>
            <th className="tableHeader"></th>
            <th className="tableHeader"></th>
            <th className="tableHeader"></th>
            <th className="tableHeader"></th>
            {/* <th className="tableHeader"></th> */}
            {quotationDocument?.map((supplier, index) => (
              <th className="tableHeader text-center" colSpan={3} key={index}>
                <span className="bg-table-status bg-table-new-status px-2">
                  {supplier.organisationName} - {supplier.quotationNr}
                </span>
                {/* <div className="mt-1">Version: {supplier.qtnVersion}</div> */}
              </th>
            ))}
          </tr>
          <tr>
            <th className="tableHeader _01">SL No</th>
            <th className="tableHeader _03">Indent Document</th>
            <th className="tableHeader _03">Status</th>
            <th className="tableHeader _04">Material Code</th>
            <th className="tableHeader _04">Qty</th>
            <th className="tableHeader _04">Unit</th>
            {/* <th className="tableHeader _04"></th> */}
            {quotationDocument?.map((supplier, index) => (
              <React.Fragment key={index + 1}>
                <th className="tableHeader _04" style={{ width: "4%" }}>Final Price</th>
                <th colSpan={2} className="tableHeader _04" style={{ width: "4%" }}>Net Value</th>
                {/* <th></th> */}
                {/* <th className="tableHeader _05">Value</th> */}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {rfxQuestions?.map((question, index) => (
            <tr key={index + 1}>
              <td className="_01" style={{ width: "1%" }} >
                {question?.rfxItemNr || question?.local_id}
              </td>
              <td style={{ width: "1%" }}>{question?.documentNumber}</td>
              <td className="text-center" style={{ width: "1%" }}>
                {question?.inqItemStatus === "Acknowledged" ? (
                  <span
                    className="bg-table-status bg-table-success-status d-flex justify-content-center"
                  // style={{ width: "100px" }}
                  >
                    {question?.inqItemStatus}
                  </span>
                ) : (
                  "-"
                )}
              </td>
              <td style={{ width: "1%" }}>
                <div
                  className="ellipsis"
                  // style={{ width: "120px" }}
                  title={question?.materialDescription}
                >
                  <b>{question?.materialCode}</b> <br />
                  {question?.materialDescription}
                </div>
              </td>
              <td style={{ width: "1%" }}>{question?.indentQuantity}</td>
              <td style={{ width: "1%" }}>{question?.orderUnitOfMeasure}</td>
              {/* <td> */}
              {/* <div style={{ width: "60px" }}>
                  <span
                    style={{ marginLeft: "12px" }}
                    onClick={() => lineItemShowModal(question?.itemTextData)}
                  >
                    <i className="bi bi-calendar2-week iconTable"></i>
                  </span>
                  <span className="suppliersIcon">
                    {question?.itemTextData?.length}
                  </span>
                </div> */}
              {/* </td> */}
              {(() => {
                // Extract prices from quotationDocument
                const prices = question?.quotationDocument?.map(
                  (supplier) => parseFloat(supplier?.quotationUnitPrice)
                );

                const minPrice = Math.min(...prices);
                const maxPrice = Math.max(...prices);

                return question?.quotationDocument?.map((supplier, supplierIndex) => {
                  const price = parseFloat(supplier?.quotationUnitPrice);

                  let priceClass = "";
                  if (price === minPrice) {
                    priceClass = "text-success fw-bold"; // Green for lowest
                  } else if (price === maxPrice) {
                    priceClass = "text-danger fw-bold"; // Red for highest
                  } else {
                    priceClass = "text-dark"; // Default for others
                  }

                  return (
                    <React.Fragment key={supplierIndex}>
                      <td className={`text-end ${priceClass}`}>
                        {formatNumber(price, "comma")}
                      </td>
                      <td colSpan={2} className="text-end fw-bold text-primary">
                        {formatNumber(supplier?.qtnitemValue, "comma")}
                      </td>
                    </React.Fragment>
                  );
                });
              })()}

            </tr>
          ))}
        </tbody>
      </table>

      {/* <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      /> */}
    </div>
  );
};

export default CompareLineItemTable;
